export const integrationsDirectCdiJobs = "/integrations/direct/cdi/jobs";
